/**
 * Classe que testa os tipo Pick list multiselect
 * @author: Adalto Junior
 * DATE: 21/08/2014
 */


Monet.Format = Monet.Format || {};
Monet.Format.PICKLIST_MULTISELECT = (function () {

    function PICKLIST_MULTISELECT(value) {

        Monet.Format.ARRAY_BASED.apply(this, arguments);

        this.value = value;

        this.toGrid = function () {

            this.formatToString();

            return this;
        };

    }

    return PICKLIST_MULTISELECT;

}());
